import React from 'react';
import {
  Box,
  Divider,
  List,
  ListItemButton,
  IconButton,
  useTheme,
  Typography,
  ListItemText,
} from "@mui/material";
const SpinWheelEmbed = () => {
  return (
    <>
      <iframe 
        src="/spinwheel/index.html" 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none',
          margin: 0,
          padding: 0,
          display: 'block',  // important: avoid baseline gap
          background: '#0b1b35'
        }}
        title="SpinWheel"
      />
      </>
  );
}

export default SpinWheelEmbed;